module.exports = __webpack_public_path__ + "static/media/karelia-logo.7d75902f.jpg";